import React, { useState, useMemo } from 'react'
import './Descarregamento.scss'
import { useSubscription } from 'utils'
import request from 'services/http'
import Barcode from 'react-barcode'
import { map } from 'rxjs/operators'

const barcodeOptions = {
    background: 'transparent',
    displayValue: true,
    fontSize: 13,
    margin: 0,
    height: 70,
    width: 1.2
}

export default function TmpPrint() {

    const [barcode, setBarcode] = useState('0')

    const genBarcode$ = useMemo(() =>  request({ method: 'POST', url: '/combustivel/descarregamento/gen-barcode' }).pipe(
        map(({ response }) => setBarcode(response))
    ), [])
    useSubscription(genBarcode$)

    return (
        <div id="descarregamento-form">
            <h1>Registro de Análise da Qualidade (RESOLUÇÃO ANP Nº 9, DE 7.3.2007)</h1>

            <table>
                <tbody>
                    <tr>
                        <td colSpan={4} className='sub-header'>MEDIDAS DE TANQUE</td>
                    </tr>
                    <tr>
                        <td className='tiny-header'>ANTES DESCARREGAMENTO</td>
                        <td className='tiny-header'>APÓS DESCARREGAMENTO</td>
                    </tr>
                    <tr>
                        <td style={{ padding: 0, margin: 0, height: 45 }}>
                            <div className='vertical-text'>TANQUE</div>
                            <div></div>
                            <div style={{ marginLeft: 70 }} className='vertical-text'>RÉGUA</div>
                            <div></div>
                            <div style={{ marginLeft: 70 }} className='vertical-text'>LITROS</div>
                        </td>
                        <td style={{ padding: 0, margin: 0, height: 45 }}>
                            <div className='vertical-text'>TANQUE</div>
                            <div></div>
                            <div style={{ marginLeft: 70 }} className='vertical-text'>RÉGUA</div>
                            <div></div>
                            <div style={{ marginLeft: 70 }} className='vertical-text'>LITROS</div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: 0, margin: 0, height: 45 }}>
                            <div className='vertical-text'>TANQUE</div>
                            <div></div>
                            <div style={{ marginLeft: 70 }} className='vertical-text'>RÉGUA</div>
                            <div></div>
                            <div style={{ marginLeft: 70 }} className='vertical-text'>LITROS</div>
                        </td>
                        <td style={{ padding: 0, margin: 0, height: 45 }}>
                            <div className='vertical-text'>TANQUE</div>
                            <div></div>
                            <div style={{ marginLeft: 70 }} className='vertical-text'>RÉGUA</div>
                            <div></div>
                            <div style={{ marginLeft: 70 }} className='vertical-text'>LITROS</div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table style={{ marginTop: 20 }}>
                <tbody>
                    <tr>
                        <td colSpan={3} className='sub-header'>DADOS DO POSTO REVENDEDOR</td>
                    </tr>
                    <tr>
                        <td colSpan={2}><b>RAZÃO SOCIAL</b>: REDE DOMPEDRO DE POSTOS LTDA</td>
                        <td><b>CNPJ</b>: 02.814.510/0001-28</td>
                    </tr>
                    <tr>
                        <td colSpan={3}><b>ENDEREÇO</b>: RUA DO TESTE, 93 ABC</td>
                    </tr>
                    <tr>
                        <td><b>BAIRRO</b>: BAIRRO DE TESTE</td>
                        <td><b>CIDADE</b>: ESTIVA</td>
                        <td><b>ESTADO</b>: MG</td>
                    </tr>
                </tbody>
            </table>

            <table style={{ marginTop: 20 }}>
                <tbody>
                    <tr>
                        <td colSpan={3} className='sub-header'>DADOS DO RECEBIMENTO</td>
                    </tr>
                    <tr>
                        <td><b>Data da coleta</b>: 24/10/2019</td>
                        <td><b>Produto</b>: Diesel S500</td>
                        <td><b>Nota Fiscal do Produto</b>:</td>
                    </tr>
                    <tr>
                        <td><b>Volume recebido (litros)</b>: </td>
                        <td><b>Distribuidor</b>: ROYAL</td>
                        <td><b>CNPJ do Distribuidor</b>: 02.814.510/0001-28</td>
                    </tr>
                    <tr>
                        <td><b>Transportador</b>: TRANSPORTADORA RDP</td>
                        <td><b>CNPJ do Transp.</b>: 02.814.510/0001-28</td>
                        <td colSpan={2}><b>Placa do Caminhão</b>:</td>
                    </tr>
                    <tr>
                        <td colSpan={2}><b>Nome do Motorista</b>:</td>
                        <td><b>RG do Motorista</b>:</td>
                    </tr>
                    <tr>
                        <td colSpan={3}><b>Nome do Analista</b>:</td>
                    </tr>
                </tbody>
            </table>

            <table style={{ marginTop: 20 }}>
                <tbody>
                    <tr>
                        <td colSpan={4} className='sub-header'>RESULTADOS DA ANÁLISE</td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                            <div>
                                <b>Legenda de Aspectos</b><br />
                                I – Límpido e isento de impurezas. II – Límpido e com impureza. III – Turvo e isento de impurezas. IV – Turvo e com impurezas.
                            </div>

                            <div style={{ marginTop: 5 }}>
                                <b>Considerações de Cor</b>:<br />
                                Óleo Diesel S500 deve ser Vermelho.
                            </div>

                            <div style={{ marginTop: 5 }}>
                                <b>Massa Específica a 20ºC do Óleo Disel S500</b>:<br/>
                                815 a 865 kg/m³
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Aspecto: </td>
                        <td>Cor: </td>
                        <td>Teor de Álcool: </td>
                    </tr>
                    <tr>
                        <td style={{ width: '33.333%' }}>Densidade: </td>
                        <td style={{ width: '33.333%' }}>Temperatura: </td>
                        <td colSpan={2} style={{ width: '33.333%' }}>Massa Específica a 20ºC:</td>
                    </tr>
                </tbody>
            </table>

            <table style={{ marginTop: 20 }} id="footer-table">
                <tbody>
                    <tr>
                        <th style={{ width: '1%', whiteSpace: 'nowrap', padding: 20, verticalAlign: 'middle' }}>Assinatura do Operador</th>
                        <td></td>
                        <td rowSpan={2} style={{ width: 150, verticalAlign: 'middle' }}>
                            <Barcode {...barcodeOptions} value={barcode} />
                        </td>
                    </tr>
                    <tr>
                        <th style={{ width: '1%', whiteSpace: 'nowrap', padding: 20, verticalAlign: 'middle' }}>Assinatura do Gerente</th>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}
